import { createAction } from 'redux-actions';

export const setSelectedTabAction = createAction('SET_NAVIGATOR_TAB');

export const setStatementNavigationRefresh = createAction(
  'SET_NAVIGATION_PANEL_REFRESH',
);
